import { Stack, Image, Title } from '@mantine/core';
import GettingStarted from '@assets/company-overview.png';

function BannerCompanyOverview() {
  return (
    <Stack align="center" justify="center" mt="20vh">
      <Title c="white" ta="center">
        Company Overview
      </Title>
      <Image w="30%" src={GettingStarted} />
    </Stack>
  );
}

export { BannerCompanyOverview };
